import { render, staticRenderFns } from "./SceneSetup.vue?vue&type=template&id=ea447d18"
import script from "./SceneSetup.vue?vue&type=script&lang=js"
export * from "./SceneSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports